import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import RecurringTransferUpdateModalUI from './RecurringTransferUpdateModalUI.js'

class RecurringTransferUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      paymentAmount: this.props.scheduledTask && this.props.scheduledTask.paymentAmountF3 || '',
      paymentAmountError: null,
    }
  }

  render() {
    return (
      <RecurringTransferUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        paymentAmount={this.state.paymentAmount}
        onPaymentAmountChange={(event) => { this.setState({ paymentAmount: event.target.value }) }}
        paymentAmountError={this.state.paymentAmountError}
        setPaymentAmountError={(error) => { this.setState({ paymentAmountError: error }) }}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (!prevProps || !this.props.scheduledTask)
      return
    if (prevProps.scheduledTask && prevProps.scheduledTask.scheduledTaskId === this.props.scheduledTask.scheduledTaskId)
      return
    this.setState({
      paymentAmount: this.props.scheduledTask.paymentAmountF3,
    })
  }

  onSubmit = () => {
    if (this.state.submitted || !this.props.scheduledTask) {
      return
    }

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    const scheduledTaskId = this.props.scheduledTask.scheduledTaskId
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scheduledTasks/${scheduledTaskId}`,
      this.onSubmitCallback,
      { paymentAmountF: this.state.paymentAmount }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.onCancelClick()
        this.props.onRefreshClick()
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false,
      paymentAmount: this.props.scheduledTask && this.props.scheduledTask.paymentAmountF3 || '',
    })
    this.props.onCancelClick()
  }
}

export default RecurringTransferUpdateModalSF
